/* Tidio renders in an open shadow root. Scope the brand palette to its visual tokens only. */
(()=>{
 const apply=()=>{
  const root=document.querySelector('#tidio-chat')?.shadowRoot;
  if(!root)return false;
  if(root.querySelector('#oc-chat-brand'))return true;
  const palette=getComputedStyle(document.documentElement);
  const wine=palette.getPropertyValue('--oc-wine').trim()||'#6a2238';
  const surface=palette.getPropertyValue('--oc-surface').trim()||'#fdfbf7';
  const blush=palette.getPropertyValue('--oc-blush').trim()||'#efded9';
  const style=document.createElement('style');style.id='oc-chat-brand';
  style.textContent=`#tidio-chat-root{--custom-background:${wine}!important;--custom-text-color:${surface}!important;--custom-action-color:${wine}!important;--custom-action-color-contrast:${surface}!important;--operator-message:${blush}!important;--radius-component:6px!important;--radius-small-component:6px!important}`;
  root.appendChild(style);
  style.textContent += '@media(max-width:767px){#button.chat-closed{translate:0 calc(-1 * var(--oc-buy-clearance,0px))!important}}';
  const bars=[...document.querySelectorAll('.ocu-sticky,[data-craft-sticky],.oc-mobile-bag')];
  const update=()=>{
   let clearance=0;
   if(window.innerWidth<=767)bars.forEach(bar=>{
    const rect=bar.getBoundingClientRect(), css=getComputedStyle(bar);
    if(!bar.hidden&&css.display!=='none'&&css.visibility!=='hidden'&&rect.top<window.innerHeight&&rect.bottom>0)clearance=Math.max(clearance,window.innerHeight-rect.top);
   });
   root.host.style.setProperty('--oc-buy-clearance',clearance+'px');
  };
  const observer=new MutationObserver(update);
  const resize=new ResizeObserver(update);
  bars.forEach(bar=>{observer.observe(bar,{attributes:true,attributeFilter:['hidden','class','style']});resize.observe(bar)});
  window.addEventListener('resize',update,{passive:true});
  update();return true;
 };
 const start=()=>{
  if(apply())return;
  let attempts=0;
  const timer=setInterval(()=>{if(apply()||++attempts>=120)clearInterval(timer)},500);
  window.addEventListener('pagehide',()=>clearInterval(timer),{once:true});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
